import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReportModalDialogComponent } from '../../Billing/report-modal-dialog/report-modal-dialog.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/services/notification-service';
import { InputformatServiceService } from 'src/app/services/inputformat-service.service';
import { ServiceProviderService } from 'src/app/services/service-provider.service';
import { MatDatepicker } from '@angular/material/datepicker';
import moment, { Moment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MY_DATE_FORMATS } from 'src/app/shared/validators/mat-date-formatter';
import { forkJoin } from 'rxjs';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import * as _ from "lodash";

@Component({
    selector: 'app-sales-target-setup-popup',
    templateUrl: './sales-target-setup-popup.component.html',
    styleUrls: ['./sales-target-setup-popup.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },

        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
})

export class PopupSalesTargetSetupComponent implements OnInit {
    form: FormGroup
    @ViewChild('effectiveFrom') startDatePicker: MatDatepicker<Date>;
    selectedDate: any;
    date = new FormControl(moment());
    data: any;
    serviceProviderList: any = [];
    filterserviceProviderList: any = [];
    disableYear: boolean;
    checkForAll: boolean;
    validcheck: boolean = true;


    constructor(@Inject(MAT_DIALOG_DATA) public popupdata: any, private toast: NotificationService,
        private InputformatService: InputformatServiceService,
        private ServiceProviderService: ServiceProviderService,
        private LookupDataServiceService: LookupDataServiceService,
        public dialogRef: MatDialogRef<ReportModalDialogComponent>,) {
        this.data = this.popupdata;
    }

    ngOnInit() {
        this.FormInit();
        this.listApi();
    }

    FormInit() {
        this.form = new FormGroup({
            effectiveFrom: new FormControl(null, Validators.required),
            serviceProviderId: new FormControl(null, Validators.required),
            targetDayCount: new FormControl(null),
            targetMonthCount: new FormControl(null, Validators.required),
            targetYearCount: new FormControl(null),
            serviceprovider: new FormControl(null)
        })
        if (this.data) {
            this.form.patchValue({
                ...this.data,
                serviceprovider: this.data.providerName
            })
        }

    }

    FnmonthFilterPicker() {
        this.startDatePicker.open();
    }

    setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
        const ctrlValue = this.date.value ?? moment();
        ctrlValue.month(normalizedMonthAndYear.month());
        ctrlValue.year(normalizedMonthAndYear.year());
        this.form.controls['effectiveFrom'].setValue(ctrlValue);
        datepicker.close();
        this.fiterbydate();
    }

    fiterbydate() {
        var postData = {
            userId: this.data.userId,
            effectiveFrom: moment(this.form.value.effectiveFrom, 'MMM/YYYY').format("YYYY/MM/DD")
        };
        this.ServiceProviderService.getServiceProviderByDate(postData).subscribe((result) => {
            this.serviceProviderList = [];
            this.filterserviceProviderList = [];
            this.serviceProviderList = result;
            this.filterserviceProviderList = this.serviceProviderList.slice();
        });
        this.ServiceProviderService.getServiceProviderByDatePerYear(postData).subscribe((result) => {
            this.form.controls['targetYearCount'].setValue(result)
            if (this.form.value.targetYearCount == 0) {
                this.form.controls['targetYearCount'].setValue('')
                this.disableYear = false;
            }
            else if (this.form.value.targetYearCount !== 0) {
                this.disableYear = true;
            }
        });
    }

    listApi() {
        forkJoin({
            list: this.LookupDataServiceService.getServiceProviderForAll(),
            check: this.ServiceProviderService.getHCYearFormat(this.data.userId)
        }).subscribe(
            responses => {
                this.serviceProviderList = [];
                this.filterserviceProviderList = [];
                this.serviceProviderList = responses.list;
                this.filterserviceProviderList = this.serviceProviderList.slice();
                this.checkForAll = responses.check;
                if (!this.checkForAll) {
                    this.clearValidators('targetDayCount', false);
                    this.clearValidators('targetYearCount', true);
                } else {
                    this.clearValidators('targetDayCount', true);
                    this.clearValidators('targetYearCount', false);
                }
            })
    }

    clearValidators(controllername, isClear) {
        if (isClear) {
            this.form.controls[controllername].clearValidators();
        } else {
            this.form.controls[controllername].setValidators(Validators.required);
        }
        this.form.controls[controllername].updateValueAndValidity();
    }

    dayvalidOnKeyUp() {
        if (this.form.value.targetDayCount == "" && this.form.value.targetMonthCount != "") {
            this.validcheck = true;
        }
        else if (this.form.value.targetDayCount != "" && this.form.value.targetMonthCount == "") {
            this.validcheck = true;
        }
        else if (this.form.value.targetDayCount <= this.form.value.targetMonthCount) {
            this.validcheck = true;
        }
        else if (this.form.value.targetDayCount > this.form.value.targetMonthCount) {
            this.validcheck = false;
        }
    }

    monthvalidOnKeyUp() {
        if (this.form.value.targetDayCount == "" && this.form.value.targetMonthCount != "") {
            this.validcheck = true;
        }
        else if (this.form.value.targetDayCount != "" && this.form.value.targetMonthCount == "") {
            this.validcheck = true;
        }
        else if ((this.form.value.targetDayCount <= this.form.value.targetMonthCount) || (this.form.value.targetMonthCount == null)) {
            this.validcheck = true;
        }
        else if ((this.form.value.targetDayCount) > (this.form.value.targetMonthCount && this.form.value.targetMonthCount != null)) {
            this.validcheck = false;
        }
    }

    monthvalidOnKeyUpForHC() {
        if (this.form.value.targetMonthCount == "" && this.form.value.targetYearCount != "") {
            this.validcheck = true;
        }
        else if (this.form.value.targetMonthCount != "" && this.form.value.targetYearCount == "") {
            this.validcheck = true;
        }
        else if (this.form.value.targetMonthCount <= this.form.value.targetYearCount) {
            this.validcheck = true;
        }
        else if (this.form.value.targetMonthCount > this.form.value.targetYearCount) {
            this.validcheck = false;
        }
    }

    yearvalidOnKeyUpForHC() {
        if (this.form.value.targetMonthCount == "" && this.form.value.targetYearCount != "") {
            this.validcheck = true;
        }
        else if (this.form.value.targetMonthCount != "" && this.form.value.targetYearCount == "") {
            this.validcheck = true;
        }
        else if ((this.form.value.targetMonthCount <= this.form.value.targetYearCount) || (this.form.value.targetYearCount == null)) {
            this.validcheck = true;
        }
        else if ((this.form.value.targetMonthCount) > (this.form.value.targetYearCount && this.form.value.targetYearCount != null)) {
            this.validcheck = false;
        }
    }

    Close() {
        this.dialogRef.close(false);
    }

    Submit() {
        if (this.form.valid) {
            let payload = {
                ...this.data,
                ...this.form.value
            }
            this.ServiceProviderService.salesTargetSave(payload).subscribe((crudStatus) => {
                if (crudStatus == 1) {
                    this.toast.showSuccess("Data Added Successfully");
                    this.dialogRef.close(true);
                }
                else if (crudStatus == 3) {
                    this.toast.showSuccess("Data Updated Successfully");
                    this.dialogRef.close(true);
                }
            });
        }
        else {
            this.toast.showError("Please fill the require fields!")
            this.form.markAllAsTouched()
            return
        }
    }
    onInputChangeNumber(event: Event, controllerName: any) {
        if (this.form.get(controllerName).value.startsWith('0')) {
            this.form.controls[controllerName].setValue(this.form.get(controllerName).value.slice(1));
        }
    }

    onInput(event: any, regexPattern: any): void {
        this.InputformatService.isNumericOrHyphenOrSpace(event, regexPattern);
    }

    monthChange() {
        if (this.checkForAll) {
            this.monthvalidOnKeyUpForHC();
        } else {
            this.monthvalidOnKeyUp();
        }
    }

    openStartDateDatePicker() {
        this.startDatePicker.open();
    }

    getvalue() {
        setTimeout(() => {
            let serviceprovider = _.find(this.serviceProviderList, ['key', (this.form.value.serviceProviderId)])?.value
            this.form.get('serviceprovider')?.setValue(serviceprovider);
        }, 10);
    }

}
